// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  profileId: __t.u64().primaryKey().name("profile_id"),
  weather: __t.string(),
  particleKind: __t.string().name("particle_kind"),
  particleDensity: __t.f32().name("particle_density"),
  fogDensity: __t.f32().name("fog_density"),
  fogColorHex: __t.string().name("fog_color_hex"),
  windStrength: __t.f32().name("wind_strength"),
  wetness: __t.f32(),
});
